// A photo (JPEG, PNG, WebP, BMP, TIFF) of a report has no text layer: it goes straight to the server's scan reader (OCR + second reading
// + navigator check). HEIC and GIF cannot be decoded by the scan reader.
export const isScanImage = (mime) => /^image\/(jpe?g|png|webp|bmp|x-ms-bmp|tiff?)$/i.test(mime || '');
